module.exports = __webpack_public_path__ + "img/madera021.51652a1a.jpg";